import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {GameInfo, OpenGameParameters} from '../../../services/games/game-info';
import {TitleComponent} from './title/title.component';
import {TrailerOrStripeImageComponent} from '../common/trailer-or-stripe-image/trailer-or-stripe-image.component';
import {GamePreviewInfoContainerComponent} from '../common/game-info-container/game-preview-info-container.component';
import {observer} from 'mobx-react';
import {IModalDialogHandler} from '../../../services/dialog/dialog.service.interface';
import {GameIconAndPlayButtonsComponent} from './game-icon-and-play-buttons/game-icon-and-play-buttons.component';
import {IntermediatePageBox} from './boxes/intermediate-page/intermediate-page.box';
import {StripeImageAndButtonsBox} from './boxes/stripe-image-and-buttons/stripe-image-and-buttons.box';
import {GradientBox} from './boxes/gradient/gradient.box';
import {RealMoneyOnlyWarningComponent} from "./only-real-money-warning/only-real-money-warning.component";

export interface OpenGameIntermediatePageComponentProps {
    gameInfo: GameInfo;
    openGameParams: OpenGameParameters;
    dialogHandler: IModalDialogHandler;
}


export const OpenGameIntermediatePageComponent = observer(
    class OpenGameIntermediatePageComponent extends OrbitComponent<OpenGameIntermediatePageComponentProps> {

        componentDidMount() {
            super.componentDidMount();
            this.reaction(() => this.services.device.isMobile,
                (isMobile) => {
                    if(!isMobile) { // this is for when you switch from mobile to PC in the emulator or when you resize de browser window
                        this.props.dialogHandler.close();
                    }
                });
        }

        _renderOnlyRealMoneyWarning() {
            return this.props.gameInfo.allowWithdrawOnlyFromReal ? (<RealMoneyOnlyWarningComponent />) : null;
        }

        render() {
            return (
                <IntermediatePageBox className='cy-open-game-intermediate-page'>
                    <TitleComponent gameInfo={this.props.gameInfo} arenaName={this.props.openGameParams.pageName} dialogHandler={this.props.dialogHandler}/>
                    {this._renderOnlyRealMoneyWarning()}
                    <StripeImageAndButtonsBox className='cy-stripe-image-and-buttons-container'>
                        <TrailerOrStripeImageComponent gameInfo={this.props.gameInfo}/>
                        {/*GameIconAndPlayButtonsComponent and GradientBox uses position absolute to place itself over the TrailerOrStripeImageComponent because TrailerOrStripeImageComponent box has opacity 0.5 */}
                        <GradientBox className='cy-gradient'/>
                        <GameIconAndPlayButtonsComponent gameInfo={this.props.gameInfo} openGameParams={{
                            ...this.props.openGameParams,
                            showIntermediatePage: false,
                            isCalledFromIntermediatePage: true
                        }} dialogHandler={this.props.dialogHandler}/>
                    </StripeImageAndButtonsBox>
                    <GamePreviewInfoContainerComponent gameInfo={this.props.gameInfo} gameTitleComponent={null}/>
                </IntermediatePageBox>

            );
        }
    }
);